module.exports = __webpack_public_path__ + "img/none.131c11e9.jpg";